if (!customElements.get('style-inspo-carousel')) {
  customElements.define('style-inspo-carousel', class StyleInspoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-inspo-track]');
      if (!this.track) return;

      this.cards = Array.from(this.querySelectorAll('[data-inspo-card]'));
      this.previous = this.querySelector('[data-inspo-previous]');
      this.next = this.querySelector('[data-inspo-next]');
      this.onScroll = () => this.updateButtons();
      this.onResize = () => this.updateButtons();
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onBlockSelect = (event) => {
        const card = event.target.closest('[data-inspo-card]');
        if (card && this.contains(card)) {
          this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'smooth' });
        }
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.updateButtons();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.previous.removeEventListener('click', this.onPrevious);
      this.next.removeEventListener('click', this.onNext);
    }

    move(direction) {
      if (!this.cards.length) return;
      const cardWidth = this.cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cardWidth + gap;
      const visibleCount = Math.max(1, Math.round(this.track.clientWidth / step));
      const currentIndex = Math.round(this.track.scrollLeft / step);
      const targetIndex = Math.max(0, Math.min(this.cards.length - 1, currentIndex + direction * visibleCount));
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: this.cards[targetIndex].offsetLeft - this.cards[0].offsetLeft, behavior });
    }

    updateButtons() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previous.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= maximum - 1;
    }
  });
}
